module.exports = __webpack_public_path__ + "img/header_bg.5049be80.png";